import ValidService from "../../../service/ValidService";
import moment from "moment";

let model = {};

// dữ liệu form
model.dataForm = {
  objectDTO: {
    dateValue: null
  },
  survey: {
    code: null, //string, required, pattern: /^[\w.]+$/, minLength: 1 // Mã biểu mẫu
    name: null, //string, required, minLength: 1 // Tên biểu mẫu
    description: null, //string, optional // Mô tả về biểu mẫu
    creatorId: null, //IdRef, optional // Mã hệ thống tạo biểu mẫu
    isEnabled: true, //boolean, required // Cho biết chỉ số vẫn còn hiệu lực hay không
    expriedDate: null, //datetime, optional // Ngày hết hạn gửi biểu mẫu
    isDeleted: false, //boolean, required // Cờ đánh dấu xóa mềm
    deletedUserId: null, //IdRef, optional // Mã người xóa
    deletedTime: null, //datetime, optional // Thời điểm xóa
    //disabled: false, //boolean, required // Cho biết tài khoản có bị khóa hay không, nếu bị khóa, tài khoản sẽ không thể đăng nhập được
    //roles: ["Admin", "Owner"], //array of string, required // Danh sách quyền của người dùng.
  },
  surveyItems: [],
  visibleSurveyItem:{},
  // surveyItem: {
  //   code: null,
  //   title: null,
  //   surveyId: null,
  //   dataType: null,
  //   inputControl: null,
  //   isRange: false,
  //   isMultipleValue: false,
  //   dataSource: {
  //     // isFixData: true,
  //     // sourceData: null,
  //     // value: null
  //   },
  //   validation: {
  //     required: false,
  //     min: 0,
  //     max: 0,
  //     length: 0,
  //     minLength: 0,
  //     maxLength: 0,
  //     pattern: null,
  //     patternMessage: null
  //   },
  //   order: 0
  // },
  mapDataObject: {
    value: [],
    geoJson: {
      type: '',
      coordinates: []
    },
  },
};

// validation form
model.validForm = {};

// dữ liệu mẫu các form khác
model.dataFormOther = {};

// validation các form khác
model.validFormOther = {};

model.tableRules = {};

export default model;
